module.exports = function() {
  return new Worker(__webpack_public_path__ + "754f5a9cb2d147eaf241.worker.js");
};